'use strict';
import $ from 'jquery';

export default class search {
	constructor() {
        
        $('#close-search-bar').on('click', function(e){
            e.preventDefault;
            $('#block-mgs-search').removeClass('is-active');
        });

        $('#desktop-search-btn,#mobile-search-btn').on('click', function(e){
            e.preventDefault;

            $('.form-search').focus();
            $(this).toggleClass('is-active');
            $('#block-mgs-search').toggleClass('is-active');
            
            if ($('.main-nav .menu-l2').is(':visible')) {
                $('.main-nav .menu-l2').fadeOut();
            }
            
        });
	}
}